import type { FC, LazyExoticComponent } from 'react';
import { Suspense } from 'react';
import { Loader } from '@components/core/Loader/Loader';

export const withSuspense = (Component: LazyExoticComponent<FC>) => (
  <Suspense fallback={<Loader />}>
    <Component />
  </Suspense>
);
